/**
 * Quadratic presets for the quadratic-workshop experiment.
 * Stored as a, b, c coefficients for ax² + bx + c = 0.
 */

export interface QuadraticPreset {
  id: string;
  a: number | string; // integer or fraction string like "1" or "2/3"
  b: number | string;
  c: number | string;
}

export const QUADRATIC_PRESETS: readonly QuadraticPreset[] = [
  { id: 'rational-1', a: 1, b: -5, c: 6 },
  { id: 'rational-2', a: 1, b: 3, c: -10 },
  { id: 'irrational', a: 1, b: 0, c: -2 },
  { id: 'complex', a: 1, b: 1, c: 1 },
  { id: 'non-monic', a: 2, b: 3, c: -5 },
];

/**
 * Validate that a preset has all required fields and valid structure.
 */
export function isValidPreset(p: QuadraticPreset): boolean {
  // id must be non-empty string
  if (typeof p.id !== 'string' || p.id.length === 0) {
    return false;
  }

  // a, b, c must be numbers or strings, non-zero for a
  if (
    (typeof p.a !== 'number' && typeof p.a !== 'string') ||
    (typeof p.b !== 'number' && typeof p.b !== 'string') ||
    (typeof p.c !== 'number' && typeof p.c !== 'string')
  ) {
    return false;
  }

  return true;
}
